import { render } from "./PageReportPerformance.vue?vue&type=template&id=45fe661b&ts=true"
import script from "./PageReportPerformance.vue?vue&type=script&lang=ts"
export * from "./PageReportPerformance.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\project\\CDM_QR-Access-Control-System-3\\DoorWebApp_Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__